import React, {useState} from "react";
import {Modal, Radio} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import {useWindowSize} from "hooks/useWindowSize";

const radioStyle = {
    whiteSpace: "normal",
    display: "flex",
    alignItems: "flex-start"
};

export const ExportExcelModal = ({visible, onClose, onConfirm, confirmLoading}) => {
    const [language, setLanguage] = useState("en");
    const isMobile = useWindowSize().width <= 768;

    const handleOk = () => {
        onConfirm(language);
    };

    return (
        <Modal
            visible={visible}
            width={isMobile ? "92%" : 640}
            title={
                <span>
                    <DownloadOutlined style={{marginRight: 8}} /> Kurye Durumu ve İşe Alım Durumu
                    Çıktı Formatı
                </span>
            }
            okText="Tamam"
            cancelText="İptal"
            centered
            confirmLoading={confirmLoading}
            onOk={handleOk}
            onCancel={onClose}
        >
            <div>
                <div style={{marginBottom: 12}}>
                    Kurye raporunda Kurye Durumu ve İşe Alım Durumlarının nasıl gösterileceğini
                    seçin.
                </div>
                <Radio.Group
                    value={language}
                    onChange={event => setLanguage(event.target.value)}
                    style={{display: "flex", flexDirection: "column", gap: 12, width: "100%"}}
                >
                    <Radio value="tr" style={radioStyle}>
                        Türkçe (Örnek: Aday, Belge Yükleme Beklenmekte)
                    </Radio>
                    <Radio value="en" style={radioStyle}>
                        İngilizce (Örnek: candidate, documentsUpload)
                    </Radio>
                </Radio.Group>
            </div>
        </Modal>
    );
};
